import { render, staticRenderFns } from "./vistorAvatar.vue?vue&type=template&id=f3ccbf4e&scoped=true&"
import script from "./vistorAvatar.vue?vue&type=script&lang=ts&"
export * from "./vistorAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./vistorAvatar.vue?vue&type=style&index=0&id=f3ccbf4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ccbf4e",
  null
  
)

export default component.exports